import coverImg from '../../../assets/images/literature/cyrus-cable-cover.jpg';

const SEGMENTS = [
    {
        id: 'cyrus-cable-1',
        title: 'The Foolish Plan',
        text: `COME, listen all unto my song;
 It is no silly fable;
'T is all about the mighty cord
 They call the Atlantic Cable.

Bold Cyrus Field he said, says he,
 I have a pretty notion
That I can run a telegraph
 Across the Atlantic Ocean.

Then all the people laughed, and said,
 They'd like to see him do it;
He might get half-seas-over, but
 He never could go through it.

To carry out his foolish plan
 He never would be able;
He might as well go hang himself
 With his Atlantic Cable.`,
        morseText: '| | | COME LISTEN ALL UNTO MY SONG IT IS NO SILLY FABLE T IS ALL ABOUT THE MIGHTY CORD THEY CALL THE ATLANTIC CABLE BK BOLD CYRUS FIELD HE SAID SAYS HE I HAVE A PRETTY NOTION THAT I CAN RUN A TELEGRAPH ACROSS THE ATLANTIC OCEAN BK THEN ALL THE PEOPLE LAUGHED AND SAID THEYD LIKE TO SEE HIM DO IT HE MIGHT GET HALF SEAS OVER BUT HE NEVER COULD GO THROUGH IT BK TO CARRY OUT HIS FOOLISH PLAN HE NEVER WOULD BE ABLE HE MIGHT AS WELL GO HANG HIMSELF WITH HIS ATLANTIC CABLE BK',
        estimatedSeconds: { wpm15: 180, wpm20: 135, wpm25: 108 },
        questions: [
            {
                id: 'cyrus-q1',
                question: 'Who is the "bold" man who proposed the Atlantic Cable?',
                options: ['SAMUEL MORSE', 'ALFRED VAIL', 'CYRUS FIELD', 'THOMAS EDISON'],
                answer: 'CYRUS FIELD',
                difficulty: 'Beginner'
            },
            {
                id: 'cyrus-q2',
                question: 'What did people do when they first heard of his plan?',
                options: ['THEY CHEERED', 'THEY LAUGHED', 'THEY CRIED', 'THEY IGNORED HIM'],
                answer: 'THEY LAUGHED',
                difficulty: 'Beginner'
            }
        ]
    },
    {
        id: 'cyrus-cable-2',
        title: 'The Valiant Man',
        text: `But Cyrus was a valiant man,
 A fellow of decision;
And heeded not their mocking words,
 Their laughter and derision.

Twice did his bravest efforts fail,
 And yet his mind was stable;
He wa'n't the man to break his heart
 Because he broke his cable.

"Once more, my gallant boys!" he cried:
 "Three times!—you know the fable,—
(I'll make it thirty," muttered he,
 "But I will lay the cable!")

Once more they tried,—hurrah! hurrah!
 What means this great commotion?
The Lord be praised! the cable's laid
 Across the Atlantic Ocean!`,
        morseText: '| | BUT CYRUS WAS A VALIANT MAN A FELLOW OF DECISION AND HEEDED NOT THEIR MOCKING WORDS THEIR LAUGHTER AND DERISION BK TWICE DID HIS BRAVEST EFFORTS FAIL AND YET HIS MIND WAS STABLE HE WANT THE MAN TO BREAK HIS HEART BECAUSE HE BROKE HIS CABLE BK ONCE MORE MY GALLANT BOYS HE CRIED THREE TIMES YOU KNOW THE FABLE ILL MAKE IT THIRTY MUTTERED HE BUT I WILL LAY THE CABLE BK ONCE MORE THEY TRIED HURRAH HURRAH WHAT MEANS THIS GREAT COMMOTION THE LORD BE PRAISED THE CABLES LAID ACROSS THE ATLANTIC OCEAN BK',
        estimatedSeconds: { wpm15: 180, wpm20: 135, wpm25: 108 },
        questions: [
            {
                id: 'cyrus-q3',
                question: 'How many times did Cyrus say he would try if needed?',
                options: ['THREE TIMES', 'THIRTY TIMES', 'TWICE', 'TEN TIMES'],
                answer: 'THIRTY TIMES',
                difficulty: 'Intermediate'
            },
            {
                id: 'cyrus-q4',
                question: 'What happened after the bravest efforts failed twice?',
                options: ['HE GAVE UP', 'HE CRIED', 'HE TRIED AGAIN', 'HE HUNG HIMSELF'],
                answer: 'HE TRIED AGAIN',
                difficulty: 'Beginner'
            }
        ]
    },
    {
        id: 'cyrus-cable-3',
        title: 'The Eldest Daughter',
        text: `Loud ring the bells,—for, flashing through
 Six hundred leagues of water,
Old Mother England's benison
 Salutes her eldest daughter!

O'er all the land the tidings speed,
 And soon, in every nation,
They'll hear about the cable with
 Profoundest admiration!

Now, long live President and Queen;
 And long live gallant Cyrus;
And may his courage, faith, and zeal
 With emulation fire us;

And may we honor evermore
 The manly, bold, and stable;
And tell our sons, to make them brave,
 How Cyrus laid the cable!`,
        morseText: '| | LOUD RING THE BELLS FOR FLASHING THROUGH SIX HUNDRED LEAGUES OF WATER OLD MOTHER ENGLANDS BENISON SALUTES HER ELDEST DAUGHTER BK OER ALL THE LAND THE TIDINGS SPEED AND SOON IN EVERY NATION THEYLL HEAR ABOUT THE CABLE WITH PROFOUNDEST ADMIRATION BK NOW LONG LIVE PRESIDENT AND QUEEN AND LONG LIVE GALLANT CYRUS AND MAY HIS COURAGE FAITH AND ZEAL WITH EMULATION FIRE US BK AND MAY WE HONOR EVERMORE THE MANLY BOLD AND STABLE AND TELL OUR SONS TO MAKE THEM BRAVE HOW CYRUS LAID THE CABLE BK',
        estimatedSeconds: { wpm15: 180, wpm20: 135, wpm25: 108 },
        questions: [
            {
                id: 'cyrus-q5',
                question: 'Who is the "eldest daughter" saluted by Mother England?',
                options: ['AMERICA', 'FRANCE', 'INDIA', 'CANADA'],
                answer: 'AMERICA',
                difficulty: 'Intermediate'
            },
            {
                id: 'cyrus-q6',
                question: 'How far through the water was the message flashing?',
                options: ['SIXTY MILES', 'SIX HUNDRED LEAGUES', 'SIX THOUSAND FEET', 'SIX MILES'],
                answer: 'SIX HUNDRED LEAGUES',
                difficulty: 'Intermediate'
            }
        ]
    }
];

export default {
    id: 'poem-how-cyrus-laid-the-cable',
    type: 'poem',
    title: 'How Cyrus Laid the Cable',
    author: 'John Godfrey Saxe',
    publicationDate: '1866',
    coverImage: coverImg,
    genres: ['Victorian Poetry', 'Historical', 'Telegraphy', 'Atlantic Cable'],
    characterLength: SEGMENTS.reduce((acc, s) => acc + s.text.length, 0),
    description: "A rhythmic poem chronicling Cyrus Field's persistent and successful efforts to lay the first transatlantic cable.",

    text: SEGMENTS.map(s => s.text).join('\n\n'),
    comprehensionQuestions: SEGMENTS.flatMap(s => s.questions),
    segments: SEGMENTS.map(s => ({
        ...s,
        comprehensionQuestions: s.questions.map(q => q.id)
    })),

    metadata: {
        setting: 'The Atlantic Ocean / USA & England',
        period: 'Mid-19th Century (1866)',
        themes: ['Persistence', 'Skepticism', 'Global Unity', 'Innovation'],
        difficulty: 'Beginner',
        estimatedReadingTimeMinutes: 6,
        stanzas: 12
    }
};
